import {PlayerBase} from "../../player/player.base";
import {Component, Injector, ViewChild} from '@angular/core';
import {Observable, of, switchMap, takeUntil} from 'rxjs';
import {catchError} from "rxjs/operators";

@Component({
  selector: 'app-text-input',
  template: `
    <div #component style="border: 2px solid black; border-radius: 4px; overflow: hidden; border-bottom-color:#7b7b7b; border-right-color:#7b7b7b">
      <div style="width: 100%; height: 100%; display: grid;" [style.backgroundColor]="bgColor">
        <div #inp contentEditable="true" style="text-align:{{fontStyle?.align}}; alignSelf: {{fontStyle?.alignSelf}}; margin: 0px; lineHeight: 1; background: none; outline: none; border: none; overflow: hidden; caretColor: white; userSelect: none; resize: none; whiteSpace: pre-wrap" [style.fontSize]="fontSize" [style.color]="color" [style.fontFamily]="fontFamily" (focusin)="onFocusIn()" (focusout)="onFocusOut()" (input)="changeValue($event)">{{text}}</div>
      </div>
    </div>`,
  styleUrls: []
})
export class TextInputComponent extends PlayerBase {
  @ViewChild('inp', {static: true} ) inp;
  fontSize;
  color;
  bgColor;
  fontFamily;
  text: string;
  sprite;
  fontStyle;

  //

  constructor(protected  injector: Injector) {
    super(injector);
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        const font = this.data.TextInput[0].Font[0].$;
        this.fontStyle = this.getFontStyle(font);
        return this.playerService.caching.requestFont(font);
      }),
      switchMap( a => {
        this.fontSize = this.fontStyle.fontSize + 'px';
        this.color = this.fontStyle.fill;
        this.fontFamily = this.fontStyle.fontFamily;
        let childProviderData;
        if (this.parentPlayer!= null) {
          childProviderData = (<any>this.parentPlayer).childProviderData;
        }
        return this.invalidateData(childProviderData);
      }),
      catchError(err => this.logError(err)),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }

  onFocusIn() {
    this.component.nativeElement.style.borderBottomColor = '#000000';
    this.component.nativeElement.style.borderRightColor = '#000000';
  }

  onFocusOut() {
    this.component.nativeElement.style.borderBottomColor = '#7b7b7b';
    this.component.nativeElement.style.borderRightColor = '#7b7b7b';
  }

  createBackgroundAction() {
      const color = Number(this.data.Background[0].$.color);
      const r = color & 0xff;
      const g = (color>>8) & 0xff;
      const b = (color>>16) & 0xff;
      const alpha = Number(this.data.Background[0].$.alpha);

      this.bgColor = 'rgba(' + b + ',' + g + ',' + r + ',' +  alpha + ')';

  }

    clearEffects() {
      super.clearEffects();
        this.bgColor = '';
    }


    invalidateData(providerData: any): Observable<any> {
    this.providerData = providerData;
    if (this.providerData!=null) {
      let value = this.providerData[this.data.TextInput[0].$.fieldName];
      if (value == null) {
        value = this.providerData[this.data.TextInput[0].$.fieldName] = this.data.TextInput[0].$.defaultValue;
      }
      this.text = value;
    } else {
      if (this.editMode) {
        this.text = "INPUT";
      }
    }
    this.changeDetectorRef.detectChanges();
    return of(null);
  }

  changeValue(event) {
    if (this.providerData!=null) {
      this.text = event.target.innerText;
      const fieldName = this.data.TextInput[0].$.fieldName;
      this.providerData[fieldName] = this.text;
      this.onClick(null);
    }
  }
}
